import { getMatrixItemsByPackagingFormat } from "../getMatrixItemsByPackagingFormat";
import { getMatrixItemsByPurchaseType } from "../getMatrixItemsByPurchaseType";
const findNextFormatByIndex = (packagingFormats, availableFormatsIds, nextIndex) => {
    const nextFormat = nextIndex >= packagingFormats.length - 1 ? packagingFormats[0] : packagingFormats[nextIndex];
    const isOfNewPurchaseType = availableFormatsIds.find((formatId) => formatId === nextFormat.id);
    if (!isOfNewPurchaseType) {
        return findNextFormatByIndex(packagingFormats, availableFormatsIds, nextIndex + 1);
    }
    return nextFormat;
};
export const getMatrixItemForNextAvailablePackagingFormat = (matrixData, currentPackagingFormatId, purchaseType, flavorId) => {
    const availableFormatsIds = matrixData.items.map((item) => item.packagingFormatId).flat();
    const currentFormatPosition = matrixData.packagingFormats.findIndex((format) => format.id === currentPackagingFormatId);
    const nextFormat = findNextFormatByIndex(matrixData.packagingFormats, availableFormatsIds, currentFormatPosition + 1);
    const matrixItemsWithNewPurchaseType = getMatrixItemsByPurchaseType(matrixData, purchaseType);
    const matrixItemsWithNextFormat = getMatrixItemsByPackagingFormat(matrixItemsWithNewPurchaseType, nextFormat.id);
    const nextMatrixItemWithSameFlavor = flavorId
        ? matrixItemsWithNextFormat.find((item) => item.flavorDetails?.flavour === flavorId)
        : undefined;
    const matrixItemWithNextFormat = nextMatrixItemWithSameFlavor ?? matrixItemsWithNextFormat[0];
    return matrixItemWithNextFormat;
};
//# sourceMappingURL=getMatrixItemForNextAvailablePackagingFormat.js.map